import React from "react";
import useTranslation from "@hooks/use_translation";
import type { GhrTask } from "@/types/task";
import TaskCard from "./TaskCard";
import FormIcon from "@/sprout/icons/form";
import JobInfo from "./JobInfo";

interface TaskCardProps {
  statusText: string;
  task: GhrTask;
}

const TakeHomeTest: React.FC<TaskCardProps> = ({ statusText, task }) => {
  const { t } = useTranslation("tasks");
  const isThirdParty = !task.url;

  return (
    <TaskCard
      icon={<FormIcon />}
      statusText={statusText}
      task={task}
      title={t(isThirdParty ? "takeHomeTest.third_party_title" : "takeHomeTest.title")}
      body={<JobInfo task={task} />}
      helpText={isThirdParty ? t("takeHomeTest.third_party_help_text") : undefined}
      actionHref={task.url || undefined}
      actionText={t("takeHomeTest.review_and_upload")}
      dismissable={false}
      theme={{
        colors: {
          background: "bg-white",
          border: "border-gray-700",
          iconBackground: "bg-gray-500",
        },
      }}
    />
  );
};

export default TakeHomeTest;
